// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__35GC2","tab":"Tabs_tab__15IyX","tabActive":"Tabs_tabActive__3CuWi"};